/** @format */

import { TDevice } from "../declarations/maps/devices";
import { TStore } from "../declarations/store";

export const selectorDeviceList = (store: TStore): TDevice[] => store.devices.deviceList || [];

export const selectorDevice = (store: TStore, id: string): TDevice | undefined =>
  store.devices.deviceList?.find(device => device.id === id) || undefined;
